import React from 'react'
import { injectIntl } from 'react-intl'
import classnames from 'classnames'
import { withLocation, withNotifications } from 'redux/enhancers'
import SurveyEventIcon from 'assets/img/survey-event-icon.svg'
import style from './style.module.scss'

const SurveySnippet = ({ data, intl: { formatMessage, locale }, unread, notificationId, readNotice}) => {
  if (!data)
    return null

  const clickHandler = () => {
    if (data.survey && data.survey.url) {
      window.open(`${data.survey.url}&lang=${locale}`,'_blank')
    };

    readNotice(notificationId)
  }

  return (
    <div
      className={classnames(style.surveySnippet, { [style.unread]: unread })}
      onClick={clickHandler}
      onKeyPress={clickHandler}
      role="button"
      tabIndex={0}
    >
      <img src={SurveyEventIcon} alt="" />
      <div className={style.info}>
        {formatMessage({ id: 'notifications.notification.survey.title' })}
      </div>
    </div>
  )
}

export default withLocation(withNotifications(injectIntl(SurveySnippet)))
